export const coupons = {
  list_title: "Coupons",
  list_cta: "Create coupon",
  list_empty_title: "You don't have coupons yet",
  list_empty_description:
    "Create your first coupon to attract more customers with redeemable discounts.",
  search_placeholder: "Search coupon",
  reload: "Reload",
  filters: {
    actives: "Active",
    inactive: "Inactive",
    finished: "Finished",
  },
  status: {
    active: "Active",
    inactive: "Inactive",
    finished: "Finished",
  },
  card: {
    all_store: "Entire store",
    products: "{{count}} products",
    code: "Code {{code}}",
    usages: "{{current}} / {{max}} uses",
    usages_unlimited: "{{current}} uses",
    always_available: "No expiration date",
    valid_from: "From {{date}}",
    valid_until: "Until {{date}}",
    valid_range: "{{start}} - {{end}}",
  },
  delete_modal: {
    title: "Delete coupon",
    description:
      "Are you sure you want to delete this coupon? This action cannot be undone.",
    cancel: "Cancel",
    delete: "Delete",
  },
  wizard: {
    title_create: "Create coupon",
    title_edit: "Edit coupon",
    back: "Back",
    save: "Save coupon",
    create: "Create coupon",
    locked_hint:
      "Some fields cannot be edited because the coupon was already shared.",
  },
  form: {
    name: "Coupon name",
    name_placeholder: "E.g. Summer discount",
    code_preview: "Generated code",
    discount_type: "Discount type",
    type_percentage: "Percentage",
    type_value: "Fixed amount",
    discount_value: "Discount value",
    scope: "Scope",
    scope_store: "Entire store",
    scope_products: "Specific products",
    schedule_dates: "Schedule validity",
    start_date: "Start date",
    end_date: "End date",
    usage_limit: "Limit number of uses",
    max_usages: "Maximum uses",
    purchase_condition: "Purchase condition",
    purchase_none: "No condition",
    purchase_first_order: "First purchase only",
    purchase_min: "Minimum purchase",
    min_purchase_value: "Minimum amount",
  },
  selector: {
    search_products: "Search product",
    no_products: "You have no available products",
    max_products: "You can select up to {{count}} products",
    selected_count: "{{count}} selected",
  },
  detail: {
    title: "Coupon detail",
    edit: "Edit",
    code: "Code",
    discount: "Discount",
    dates: "Validity",
    no_dates: "No scheduled dates",
    usages: "Uses",
    scope: "Scope",
    purchase_condition: "Condition",
    redemptions: "Redemptions",
    no_redemptions: "No redemptions yet",
    customer: "Customer",
    phone: "Phone",
    date: "Date",
    copy_code: "Copy code",
    copy_link: "Copy store link",
    copied: "Copied",
  },
  messages: {
    created: "Coupon created successfully",
    updated: "Coupon updated successfully",
    deleted: "Coupon deleted",
    error_save: "Could not save the coupon",
    error_delete: "Could not delete the coupon",
    error_load: "Could not load coupons",
    validation_generic: "Please review the form fields",
    validation_name: "Name is required",
    validation_discount: "Enter a valid discount",
    validation_scope: "Select up to 5 products or the entire store",
  },
};
